import React from 'react';

type Props = {
  label: any;
  value: any;
  valueProps?: React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement>;
  labelProps?: React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement>;
  valueClassName?: string;
};

export default function LabelValueItem({ label, value, valueProps, labelProps, valueClassName }: Props) {
  return (
    <>
      <div className="text-dark-2" {...labelProps}>
        {label}
      </div>
      <div className={valueClassName || 'fw-500 bg-light-2 rounded p-2'} style={{ minHeight: 46 }} {...valueProps}>
        {value}
      </div>
    </>
  );
}
